module.exports = __webpack_public_path__ + "static/media/front.0c5f81c6.jpg";